import { useState, useEffect } from "react";
import { GetLocalAuthToken, HandleExpiredToken } from "../services/MoblyzeAuth";

const useScreeningConversation = (jobId, userId, shouldFetch = false) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!jobId || !userId || !shouldFetch) return;

    const fetchScreeningData = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const token = await GetLocalAuthToken();
        
        const response = await fetch(
          `${process.env.REACT_APP_AI_WORKER_DOMAIN}/admin/screening/conversations/by-job-user?jobId=${encodeURIComponent(jobId)}&userId=${encodeURIComponent(userId)}`,
          {
            headers: {
              'Authorization': token ? `Bearer ${token}` : '',
              'Content-Type': 'application/json',
            },
          }
        );
        
        if (!response.ok) {
          if (response.status === 401 || response.status === 403) {
            HandleExpiredToken();
            return;
          }
          let msg = 'Failed to fetch screening conversation';
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            try {
              const result = await response.json();
              msg = result?.error || msg;
            } catch {
              // Use default message if response is not JSON
            }
          } else {
            try {
              const text = await response.text();
              if (text) {
                msg = text;
              }
            } catch {
              // Use default message if response text can't be read
            }
          }
          throw new Error(msg);
        }
        
        const result = await response.json();
        setData(result);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchScreeningData();
  }, [jobId, userId, shouldFetch]);

  return { data, loading, error };
};

export default useScreeningConversation;